module.exports = __webpack_public_path__ + "static/media/medical-square-full.362d5087.svg";